export default "__VITE_ASSET__Cly4KgJU__"